import { render } from "./Index.vue?vue&type=template&id=546b2d5a&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=546b2d5a&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-546b2d5a"]])

export default __exports__